import script from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CookieBanner.vue?vue&type=style&index=0&id=25b8732a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b8732a"]])

export default __exports__